document.addEventListener('alpine:init', () => {
  Alpine.data('gallery', (total) => ({
    current: 0,
    total,
    touchStartX: null,

    next() {
      if (this.current < this.total - 1) this.current++;
    },

    prev() {
      if (this.current > 0) this.current--;
    },

    goTo(index) {
      this.current = index;
    },

    // Swipe: compare horizontal travel between touchstart and touchend; a move
    // past the threshold advances (left) or rewinds (right) a slide.
    onTouchStart(e) {
      this.touchStartX = e.changedTouches[0].screenX;
    },

    onTouchEnd(e) {
      if (this.touchStartX === null || this.total <= 1) return;
      const dx = e.changedTouches[0].screenX - this.touchStartX;
      if (Math.abs(dx) > 40) dx < 0 ? this.next() : this.prev();
      this.touchStartX = null;
    },
  }));
});
